module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point02_02_miyakoblue-6c6602e3ad26b44ed864d468502372d0.jpg";